import {Suspense} from 'react';
import {Outlet} from 'react-router-dom';
import {Layout as DashboardLayout} from 'src/layouts/dashboard';
import Overview from "../pages/Home";
import AccountCreateUpdateView from "../pages/Brands/AccountCreateUpdateView";
import AccountAddView from "../pages/Brands/AccountAddView";
import EstablishmentListView from "../pages/Establishments/EstablishmentListView";
import EstablishmentAddView from "../pages/Establishments/EstablishmentAddView";
import EstablishmentDetailsView from "../pages/Establishments/EstablishmentDetailsView";
import Synchronisation from "../pages/ Synchronisation";
import StaffData from "../pages/data/StaffData";
import TurnOverData from "../pages/data/TurnOverData";
import Products from "../pages/data/Products";
import AIChat from "../pages/data/IAChat";
import IAImages from "../pages/data/IAImages";
import CustomChart from "../pages/CustomChart";
import ChartImplementationListView from "../pages/ChartImplementations/ChartImplementationListView";
import ChartImplementationAddView from "../pages/ChartImplementations/ChartImplementationAddView";
import ChartImplementationDetailsView from "../pages/ChartImplementations/ChartImplementationDetailsView";
import ChartCategoryListView from "../pages/ChartCategories/ChartCategoryListView";
import ChartCategoryAddView from "../pages/ChartCategories/ChartCategoryAddView";
import ChartCategoryDetailsView from "../pages/ChartCategories/ChartCategoryDetailsView";
import Accounting from "../pages/Accounting";
import DashBoardListView from "../pages/Dashboards/DashBoardListView";
// import DashBoardListView from "../pages/Dashboards/DashBoardListView";
import DashBoardAddView from "../pages/Dashboards/DashBoardAddView";
import DashBoardDetailsView from "../pages/Dashboards/DashBoardDetailsView";
import CustomBoard from "../pages/CustomBoard";
import DataGridImplementationListView from "../pages/DataGridImplementations/DataGridImplementationListView";
import DataGridImplementationAddView from "../pages/DataGridImplementations/DataGridImplementationAddView";
import DataGridImplementationDetailsView from "../pages/DataGridImplementations/DataGridImplementationDetailsView";
import DashboardNavForMobile from "../pages/Dashboards/DashboardNavForMobile";
import NoDashboardForMobile from "../pages/Dashboards/NoDashboardForMobile";

export const boardsRoute = 'boards';

export const widgetsRoute = 'widgets';
export const widgetAddRoute = 'widgets/add';

export const accountRoute = 'account';
export const accountAddRoute = 'account/add';

export const paymentSuccessRoute = 'paymentSuccess';

export const establishmentListRoute = 'establishments';
export const establishmentAddRoute = 'establishment/add';
export const establishmentDetailRoute = 'establishments/detail/:establishmentId';

export const chartImplementationListRoute = 'chartImplementations';
export const chartImplementationAddRoute = 'chartImplementation/add';
export const chartImplementationDetailRoute = 'chartImplementations/detail/:chartImplementationId';

export const dataGridImplementationListRoute = 'dataGridImplementations';
export const dataGridImplementationAddRoute = 'dataGridImplementation/add';
export const dataGridImplementationDetailRoute = 'dataGridImplementations/detail/:dataGridImplementationId';

export const dashboardListRoute = 'dashboards';
export const dashboardAddRoute = 'dashboard/add';
export const dashboardDetailRoute = 'dashboards/detail/:dashboardId';

export const dashboardNavForMobileRoute = 'dashboardsNav';
export const noDashboardForMobileRoute = 'noDashboard';

export const chartCategoryListRoute = 'chartCategories';
export const charCategoryAddRoute = 'chartCategory/add';
export const chartCategoryDetailRoute = 'chartCategories/detail/:chartCategoryId';

export const synchronisationRoute = 'synchronisation';

export const staffDataRoute = 'staffData';
export const turnOverDataRoute = 'turnOverData';
export const productDataRoute = 'productData';
export const aiChatDataRoute = 'aiChat';
export const iaImagesDataRoute = 'iaImages';
export const customChartRoute = 'customChart';

export const accountingDataRoute = 'accounting'

export const customBoardsRoute = 'customBoards/:boardId';

export const getStartedRoute = 'getStarted';

export const dashboardBaseRoute = 'dashboard';

function DashBoardLDetailsView() {
  return null;
}

export const dashboardRoutes = [
  {
    path: dashboardBaseRoute,
    element: (
      <DashboardLayout>
        <Suspense>
          <Outlet />
        </Suspense>
      </DashboardLayout>
    ),
    children: [
      {
        index: true,
        element: <Overview />
      },
      {
        path: "/" + dashboardBaseRoute + "/" +accountRoute,
        element: <AccountCreateUpdateView />
      },
      {
        path: "/" + dashboardBaseRoute + "/" + accountAddRoute,
        element: <AccountAddView />
      },

      { path: establishmentListRoute, element: <EstablishmentListView/> },
      { path: establishmentAddRoute, element: <EstablishmentAddView/> },
      { path: establishmentDetailRoute, element: <EstablishmentDetailsView/> },

      { path: chartImplementationListRoute, element: <ChartImplementationListView/> },
      { path: chartImplementationAddRoute, element: <ChartImplementationAddView/> },
      { path: chartImplementationDetailRoute, element: <ChartImplementationDetailsView/> },

      { path: dataGridImplementationListRoute, element: <DataGridImplementationListView/> },
      { path: dataGridImplementationAddRoute, element: <DataGridImplementationAddView/> },
      { path: dataGridImplementationDetailRoute, element: <DataGridImplementationDetailsView/> },

      { path: dashboardListRoute, element: <DashBoardListView/> },
      { path: dashboardAddRoute, element: <DashBoardAddView/> },
      { path: dashboardDetailRoute, element: <DashBoardDetailsView/> },

      { path: dashboardNavForMobileRoute, element: <DashboardNavForMobile/> },
      { path: noDashboardForMobileRoute, element: <NoDashboardForMobile/> },

      { path: chartCategoryListRoute, element: <ChartCategoryListView/> },
      { path: charCategoryAddRoute, element: <ChartCategoryAddView/> },
      { path: chartCategoryDetailRoute, element: <ChartCategoryDetailsView/> },

      { path: synchronisationRoute, element: <Synchronisation/> },

      { path: staffDataRoute, element: <StaffData/> },
      { path: turnOverDataRoute, element: <TurnOverData/> },
      { path: productDataRoute, element: <Products/> },
      { path: aiChatDataRoute, element: <AIChat/> },
      { path: iaImagesDataRoute, element: <IAImages/> },
      { path: customChartRoute, element: <CustomChart/> },

      { path: accountingDataRoute, element: <Accounting/> },

      { path: customBoardsRoute, element: <CustomBoard/> },


    ]
  }
];
